export default __webpack_public_path__ + "static/media/user_badge.00df5a3d.svg";